import React from "react"
import { Link } from "react-router-dom"
import Heading from "../common/heading/Heading"
import "./about.css"
import Awrapper from "./Awrapper"

const features = [
  {
    faIcon: "fa fa-chart-line",
    title:  "Practical Trading Education",
    desc:   "Our second-to-none practical and technology-based programme gives you the edge to trade Forex, Futures and Options with confidence.",
    link:   "/features/practical-trading",
  },
  {
    faIcon: "fa fa-award",
    title:  "Earn a Trading Certificate",
    desc:   "Complete our Signature Programme and earn an industry-recognised certificate that validates your market knowledge and trading skills.",
    link:   "/features/trading-certificate",
  },
  {
    faIcon: "fa fa-user-tie",
    title:  "One-on-One Mentorship",
    desc:   "Our small-class setup enables direct instructor engagement. Real traders guide you through live market conditions — not just slides.",
    link:   "/features/mentorship",
  },
]

const AboutCard = () => {
  return (
    <>
      <section className="aboutHome">
        <div className="container">

          {/* Header — centered */}
          <div className="aboutHome-header">
            <Heading
              subtitle="ABOUT ROVERS ACCESS LIMITED"
              title="More Than a Training Provider — A Launchpad for Financial Empowerment"
            />
            <p className="about-intro-p">
              Headquartered in <strong>Nairobi, Kenya</strong>, Rovers Access Limited delivers a
              practical, technology-based trading programme. Our small-class setup enables genuine
              one-on-one instructor attention — because we believe{" "}
              <strong className="motto-highlight">gambling is not trading</strong>.
            </p>
            <p className="about-intro-p">
              Our Core Programme covers the essential rules and skills for Forex, Futures and
              Options — for hourly, daily, weekly, or swing traders. No social media hype. Just
              knowledge-based curriculum that turns theory into confident market participation.
            </p>
          </div>

          {/* Feature cards — 3 columns, each is a clickable Link */}
          <div className="aboutHome-features">
            {features.map((f, i) => (
              <Link to={f.link} key={i} className="aboutHome-feature aboutHome-feature--link">
                <div className="feature-icon-wrap">
                  <i className={f.faIcon}></i>
                </div>
                <div className="feature-text">
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                  <span className="feature-read-more">
                    Learn more <i className="fa fa-arrow-right"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>

          {/* CTA link */}
          <div className="aboutHome-footer">
            <Link to="/about" className="about-learn-more">
              Learn More About Us <i className="fa fa-arrow-right"></i>
            </Link>
          </div>

        </div>
      </section>
      <Awrapper />
    </>
  )
}

export default AboutCard
